import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = { class: "tbl-wrap" };
var _hoisted_2 = { class: "tbl tbl--border-bottom" };
import CartItem from "./CartItem.vue";
import CartEventBus from "../../CartEventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartTable',
    props: {
        initialized: Boolean,
        products: { type: Array },
    },
    setup: function (__props) {
        var props = __props;
        function enter(el, done) {
            if (!props.initialized) {
                done();
                return;
            }
            el.style.animation = 'highlight 1s ease-out forwards';
            el.addEventListener('animationend', function () {
                el.style.animation = '';
                done();
            }, { once: true });
        }
        function beforeLeave(el) {
            var maxHeight = "".concat(el.scrollHeight, "px");
            if (window.innerWidth >= 1000) {
                el.querySelectorAll('td > *').forEach(function (el) { return el.style.maxHeight = maxHeight; });
            }
            else {
                el.style.maxHeight = maxHeight;
            }
        }
        function leave(el) {
            if (window.innerWidth >= 1000) {
                el.querySelectorAll('td > *').forEach(function (el) { return el.style.maxHeight = '0'; });
            }
            else {
                el.style.maxHeight = '0';
            }
        }
        function afterLeave() {
            var _a;
            if (!((_a = props.products) === null || _a === void 0 ? void 0 : _a.length)) {
                CartEventBus.emit('cart:empty');
            }
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("table", _hoisted_2, [
                    _cache[0] || (_cache[0] = _createElementVNode("thead", { class: "cart-head" }, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, "Товары")
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, "Скидка")
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, "Цена")
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, "Кол‑во")
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, "Сумма")
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, " ")
                            ])
                        ])
                    ], -1 /* CACHED */)),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("tbody", null, [
                        _createVNode(_TransitionGroup, {
                            name: "product",
                            onEnter: enter,
                            onBeforeLeave: beforeLeave,
                            onLeave: leave,
                            onAfterLeave: afterLeave
                        }, {
                            default: _withCtx(function () { return [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products, function (product) {
                                    return (_openBlock(), _createBlock(CartItem, {
                                        key: product.cartItemId,
                                        item: product,
                                        initialized: __props.initialized
                                    }, null, 8 /* PROPS */, ["item", "initialized"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]; }),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ]));
        };
    }
});
